import { fromJS } from 'immutable';
import { useState } from 'react';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { H7 } from 'foundations-components/transitional/components/H7';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { TFlex } from 'foundations-components/transitional/components/TFlex';

// @ts-expect-error untyped import
import Any from 'customer-data-filters/filterQueryFormat/operator/Any';
import { listMembershipFromObjectSegFilterStrict, listMembershipToObjectSegFilterStrict } from '../../list-membership-utils';
import { InboundDbListMembershipSnowflakeProperty } from '../../../../metadata/lists';
// @ts-expect-error untyped import
import { CloneFilterSelect } from '../shared/CloneFilterSelect';
// @ts-expect-error untyped import
import { GroupFilterControl } from '../shared/GroupFilterControl';
import { useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
// @ts-expect-error untyped import
import { useTableSource } from '../SourceMeta';
import { toDSFieldRecord, toObjectSegAny
// @ts-expect-error untyped import
} from '../../xo-filter-utils';
import ListMembershipFilter from './ListMembershipFilter';
import ListOperatorSelect from './ListOperatorSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListFilterPanel = ({
  filter,
  groupId,
  onDone,
  onCancel,
  onCloneFilter
}) => {
  const [draftFilter, setDraft] = useState(filter);
  const [draftGroupId, setGroup] = useState(groupId);
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const draftListId = draftFilter.getIn(['filter', 'listId']);
  const draftOperator = draftFilter.getIn(['filter', 'operator']);
  const {
    field: {
      table: tableName
    }
  } = filter;
  const source = useTableSource(tableName);
  const field = toDSFieldRecord(InboundDbListMembershipSnowflakeProperty, source, userGates);
  const operatorValue = draftFilter.getIn(['filter', 'operator']) ? listMembershipFromObjectSegFilterStrict(draftFilter.filter.toJS()) : Any.of(field);
  const handleListMembershipChange = listId => {
    setDraft(draftFilter.setIn(['filter', 'listId'], listId));
  };

  // Handler for the new ListOperatorSelect component
  const handleNewOperatorChange = ({
    target: {
      value: operator
    }
  }) => {
    const nextObjectSegFilter = operator instanceof Any ? toObjectSegAny(operator) : listMembershipToObjectSegFilterStrict(operator.setIn(['field', 'name'], draftListId));
    setDraft(draftFilter.set('filter', fromJS(nextObjectSegFilter)));
  };
  const handleDone = () => {
    onDone({
      draftFilter,
      draftGroupId
    });
  };
  const handleCloneFilter = groupIndex => {
    onCloneFilter({
      draftFilter,
      groupId: groupIndex
    });
  };
  const headerText = I18n.text('reporting-snowflake.filter-editor.list-membership.field-name');
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H7, {
      children: headerText
    }), /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "operator-select",
      children: I18n.text('reporting-snowflake.filter-editor.list-membership.select-operator')
    }), /*#__PURE__*/_jsx(ListOperatorSelect, {
      id: "operator-select",
      value: operatorValue,
      onChange: handleNewOperatorChange
    }), /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormLabel, {
        htmlFor: "list-select",
        children: I18n.text('reporting-snowflake.filter-editor.list-membership.select-list')
      }), /*#__PURE__*/_jsx(ListMembershipFilter, {
        filteredLists: !isNaN(Number(draftListId)) ? [Number(draftListId)] : [],
        objectType: source.objectTypeId,
        onChange: handleListMembershipChange
      })]
    }), /*#__PURE__*/_jsx(GroupFilterControl, {
      currentGroupId: draftGroupId,
      onGroupSelected: nextGroupId => setGroup(nextGroupId)
    }), /*#__PURE__*/_jsxs(TFlex, {
      justify: "between",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          size: "xs",
          onClick: handleDone,
          disabled: !draftListId || !draftOperator,
          children: I18n.text('reporting-snowflake.filter-editor.editor-panel.apply')
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "xs",
          onClick: onCancel,
          children: I18n.text('reporting-snowflake.filter-editor.editor-panel.cancel')
        })]
      }), /*#__PURE__*/_jsx(CloneFilterSelect, {
        currentGroupId: groupId,
        onCloneFilter: handleCloneFilter
      })]
    })]
  });
};
export default ListFilterPanel;